import jsPDF from "jspdf";
import "jspdf-autotable";
import { useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { SummaryReportService } from "../../services/SummaryReportService";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from "../components/BrokerDropdown";
import ClientDropdown from "../components/ClientDropdown";
import { customStyles, the } from "../components/customStyles";
import MarketDropdown from "../components/MarketDropdown";
import MasterDropdown from "../components/MasterDropdown";
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from "../components/ScriptDropdown";
import "../custom.css";
import html2canvas from "html2canvas";
import DataTable from 'datatables.net-react';
import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';
import { isMobile } from "../../util/GeneralUtil";

function Summaryreport() {

  const pdfRef = useRef();
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [summary, setSummary] = useState([]);
  const [valanDates, setValanDates] = useState([]);
  const [selectedValan, setSelectedValan] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [valan, setValan] = useState(null);

  const navigate = useNavigate([]);

  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  useEffect(() => {
    setLoading(true);
    SummaryReportService.getSumaryData({ loginId: user.adminId,  adminId: user.adminId }).then(
      (res) => {
        setLoading(false);
        if (res.code === 1) {
          if (res.data.summaryList.length > 0) {
            setValan(res.data.valan);
            setSummary(res.data.summaryList);
          }
        } else{
          setSummary([]);
        }
      }
    );

    SummaryReportService.valanDates().then((res) => {
      if (res.code === 1) {
        if (res.data.valandates.length > 0) {
          setValanDates(res.data.valandates);
        }
      }
    });
  }, []);

  const handleReset = () => {
    
    setSelectedMarket(null);
    setSelectedScript(null);
    setSelectedValan(null);
    setSelectedAdmin( null );
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);

  };

  const handleValanDateChange = (selectedOption) => {
    setSelectedValan((prev) => {
      return selectedOption ? selectedOption.value : "";
  });
  };
  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };
  const handleScriptReset = () => {
    setSelectedScript(null);
  };

  const handleNetPositionSubmit = () => {
    var adminId;
    var uName;
    if (selectedSubBrokerId) {
      adminId = selectedSubBrokerId.value;
      uName = selectedAdmin.label;
    } else if (selectedBrokerId) {
      adminId = selectedBrokerId;
      uName = selectedAdmin.label;
    } else if (selectedMaster) {
      adminId = selectedMaster.value;
      uName = selectedAdmin.label;
    } else if (selectedAdmin) {
      adminId = selectedAdmin.value;
      uName = selectedAdmin.label;
    } else{
      adminId = user.adminId;
    }
    
    getClient(adminId, "ADMIN", uName);
  }

  const options = valanDates.map((valan) => ({
    value: valan.valanId,
    label: valan.date,
  }));
  const handleSubmit = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      loginId: user.adminId,
      segment: selectedMarket,
      keyword: selectedScript,
      valan:selectedValan
    };

    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }

    SummaryReportService.getSumaryData(dataToSubmit).then((resp) => {
      setLoading(false);
      if (resp.code === 1) {
        if (resp.data.summaryList.length > 0) {
          setValan(resp.data.valan);
          setSummary(resp.data.summaryList);
        } else {
          setSummary([]);
        }
      } else {
        setSummary([]);
      }
    });
  };

  const getUser = (uid, type, uName, fName) => {
    if(type === 'MASTER' || type === 'ADMIN') {
      navigate("/mastersummary", { state: { adminId: uid, valan: selectedValan, userName: uName, firstName: fName} });
    } else {
      navigate("/usersummary", { state: { userId:uid, valan: selectedValan, userName: uName, firstName: fName} });
    }
  };
  const getClient = (uid, type, uName, fName) => {
    if(type === 'MASTER' || type === 'ADMIN') {
      navigate("/netposition", { state: { adminId: uid, valan: selectedValan, userName: uName, firstName: fName} });
    } else {
      navigate("/netposition", { state: { userId:uid, valan: selectedValan, userName: uName, firstName: fName} });
    }
   
  };

  
  const getCurrentDate = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [columns, setColumns] = useState([
    { title: "SN.", data: "sn", className:"text-black fss-09", width:"1%" },
    { title: "NAME", data: "name", className: "text-black fss-09 text-nowrap" },
    { title: "C.BILL", data: "cBill", className: "text-center text-black fss-09 text-nowrap" },
    { title: "VLN.", data: "vln", className: "text-end text-black fss-09"},
    { title: "C.BILL.MTM <br>(Without Brok.)", data: "cBillMtm", className: "text-center text-black fss-09" },
    { title: "TOTAL BROK.", data: "totalBrok", className: "text-end text-black fss-09" },
    { title: "C.BILL.MTM <br>(With Brok.)", data: "cBillMtmWithBrok", className: "text-center text-black fss-09" },
    { title: "BROKER BRO.", data: "brokerBro", className: "text-end text-black fss-09" },
    { title: "C+B.BRO.MTM", data: "cBbroMtm", className: "text-end text-black fss-09 text-nowrap" },
    { title: "PARTNER.MTM.", data: "partnerMtm", className: "text-center text-black fss-09 text-nowrap" },
    { title: "D.MTM", data: "dMtm", className: "text-center text-black fss-09 text-nowrap " },
    { title: "UP.MTM", data: "upMtm", className: "text-center text-black fss-09 text-nowrap " },
    { title: "S.MTM", data: "sMtm", className: "text-center text-black fss-09 text-nowrap" },
    { title: "N.P", data: "np", className: "text-center text-black fss-09 " }
  ], []);


  const data = summary.map((sr, index) => ({
    sn: index + 1,
    name: `${sr.user.firstName} ${sr.user.userName ? `(${sr.user.userName})` : ""} ${
      sr.user.adminType === "MASTER" ? "(M)" :  sr.user.adminType === "ADMIN" ? "(A)" : ""
    }`,
    cBill: sr.user.firstName !== 'ZZZ-TOTAL' ?  `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-file-earmark-pdf" viewBox="0 0 16 16" style="cursor:pointer"
              data-userid="${sr.user.userid}" data-admintype="${sr.user.adminType}" data-button="cbill">
               <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
               <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
            </svg>` : '',
    vln: valan,
    cBillMtm: ReactDOMServer.renderToString(<NumberFormatter number={sr.clientBillMtm} />),
    totalBrok: ReactDOMServer.renderToString(<NumberFormatter number={sr.totalBrokerage} />),
    cBillMtmWithBrok: ReactDOMServer.renderToString(<NumberFormatter number={sr.clientBillMtmWithBrokerage} />),
    brokerBro: ReactDOMServer.renderToString(<NumberFormatter number={sr.brokerBrokerage} />),
    cBbroMtm: ReactDOMServer.renderToString(<NumberFormatter number={sr.clientBrokerBrokerageMtm} />),
    partnerMtm:  ReactDOMServer.renderToString(<div className="d-flex justify-content-center align-items-center text-nowrap"><NumberFormatter number={sr.partnerMtm} />{sr.partnerMtm !== 0 &&sr.downPercentage !== 0 && (<span> ({sr.downPercentage}%)</span>)}</div>),
    dMtm: ReactDOMServer.renderToString(<div className="d-flex justify-content-center align-items-center text-nowrap"><NumberFormatter number={sr.downMtm} /> {sr.downMtm !== 0 && sr.user?.userName ? `(${sr.downPercentage}%)` : ""}</div>),
    upMtm: ReactDOMServer.renderToString(<div className="d-flex justify-content-center align-items-center text-nowrap"><NumberFormatter number={sr.upMtm} /> {sr.upPercentage !== 0 ? `(${sr.upPercentage}%)` : ""}</div>),
    sMtm: ReactDOMServer.renderToString(<div className="d-flex justify-content-center align-items-center text-nowrap"><NumberFormatter number={sr.selfMtm} /> {sr.selfPercentage !== 0 ? `(${sr.selfPercentage}%)` : ""} </div>),
    np: sr.user.firstName !== 'ZZZ-TOTAL' ? `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-file-earmark-pdf" viewBox="0 0 16 16" style="cursor:pointer"
            data-userid="${sr.user.userid}" data-admintype="${sr.user.adminType}" data-button="np">
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                        <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
           </svg>` : ''
  }));


  const exportToPDF = () => {
      const doc = new jsPDF();

      const currentDate = getCurrentDate();
  
      doc.setFontSize(12);
      doc.text('Summary Report', 80, 25);
  
      doc.setFontSize(12);
      doc.text(currentDate, 175, 25);
  
      const tableHeaders = [
        "SN.",
        "NAME",
        "C.BILL.MTM",
        "T.BRO.",
        "C.BILL.MTM",
        "B.BRO.",
        "C+B.BRO.MTM",
        "P.MTM",
        "D.MTM",
        "UP.MTM",
        "S.MTM",
      ];
  
      const tableData = summary.map((sr, index) => 
        [
          index + 1,
          `${sr.user.firstName} ${sr.user.userName ? `(${sr.user.userName})` : ""} ${
            sr.user.adminType === "MASTER" ? "(M)" : ""
          }`,
          removeDiv(sr.clientBillMtm),
          removeDiv(sr.totalBrokerage),
          removeDiv(sr.clientBillMtmWithBrokerage),
          removeDiv(sr.brokerBrokerage),
          removeDiv(sr.clientBrokerBrokerageMtm),
          removeDiv(sr.partnerMtm),
          removeDiv(sr.downMtm),
          removeDiv(sr.upMtm),
          removeDiv(sr.selfMtm),
        ]

    );
  
      doc.autoTable({
        head: [tableHeaders],
        body: tableData,
        startY: 30,
        theme: "grid",
        headStyles: {
          fillColor: [44, 62, 80],
          textColor: 255,
          fontSize: 8,
          font: "helvetica",
          halign: "center",
        },
        bodyStyles: {
          fontSize: 6,
          halign: "center",
          fontStyle: "bold"
        },
        margin: { top: 15, left: 4, right: 4, bottom: 10 },
      });
  
      doc.save("summaryreport.pdf");
  };

  const removeDiv = (t) => { 
    return ReactDOMServer.renderToString(<NumberFormatter number={t || 0} />).replace('<div>', '').replace('</div>','');
  }

  const handleClick = (event) => {
    if (event.target.classList.contains("bi-file-earmark-pdf")) {
        const dataId = event.target.getAttribute("data-userid");
        const adminType = event.target.getAttribute("data-admintype");
        const button = event.target.getAttribute("data-button");
        
        if(button === 'cbill'){
          getUser(dataId, adminType);
        } else if(button === 'np'){
          getClient(dataId, adminType);
        }
    }
};

useEffect(() => {
  document.addEventListener("click", handleClick);

  return () => {
    document.removeEventListener("click", handleClick);
  };
}, [summary]);


  return (
    <>
    <Row>
      <Col xs={12}>
          <Card>
            <Card.Body>
              <Row>
                <Col xs={4} xl={3}>
                  <b className="fss-05">MARKET</b>
                  <MarketDropdown
                    allScripts={allScripts}
                    onMarketChange={handleMarketChange}
                    onScriptReset={handleScriptReset}
                  />
                </Col>

                <Col xs={4} xl={3}>
                  <b className="fss-05">SCRIPT NAME</b>
                  <ScriptDropdown
                    allScripts={allScripts}
                    selectedMarket={selectedMarket}
                    onScriptChange={handleScriptChange}
                  />
                </Col>

                <Col xs={4} xl={3}>
                  <b className="fss-05">VALAN</b>
                  <Select
                    options={options}
                    value={options.find((option) => option.value === selectedValan)}
                    onChange={handleValanDateChange}
                    placeholder="Select "
                    styles={customStyles}
                    theme={the}
                    isClearable
                    className=" text-black"
                  />
                </Col>

                {(user.adminType === "SUPER_ADMIN" || user.adminType == 'SUPER_MASTER') && (
                  <Col xs={4} xl={3}>
                    <b className="fss-05">ADMIN</b>
                    <AdminDropdown
                      adminId={user.adminId}
                      setSelectedOption={setSelectedAdmin}
                    />
                  </Col>
                )}

                {(user.adminType === "SUPER_ADMIN" ||
                  user.adminType === "ADMIN" || user.adminType == 'SUPER_MASTER' ) && (
                  <Col xs={4} xl={3}>
                    <b className="fss-05">MASTER</b>
                    <MasterDropdown
                    
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      setSelectedOption={setSelectedMaster}
                      setSelectedMaster={setSelectedMaster}
                      setSelectedBrokerId={setSelectedBrokerId}
                    />
                  </Col>
                )}

                {(user.adminType === "SUPER_ADMIN" ||
                  user.adminType === "ADMIN" ||
                  user.adminType === "MASTER" || user.adminType == 'SUPER_MASTER') && (
                  <Col xs={4} xl={3}>
                    <b className="fss-05">BROKER</b>
                    <BrokerDropdown
                      selectedAdmin={selectedAdmin}
                      selectedMaster={selectedMaster}
                      setSelectedOption={setSelectedBrokerId}
                      setSelectedBrokerId={setSelectedBrokerId}
                      setSelectedSubBrokerId={setSelectedSubBrokerId}
                    />
                  </Col>
                )}

                <Col xs={4} xl={3}>
                  <b className="fss-05">CLIENT</b>
                  <ClientDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedOption={handleSelectedClientChange}
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col className="mt-1 ">
                  <Button
                    variant="secondary"
                    size="sm"
                    className="me-1 "
                    Link
                    href="/selfsummary"
                  >
                    Script Wise
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    className="me-2 "
                    onClick={handleNetPositionSubmit}
                  >
                    Net Position
                  </Button>

                  <Button
                    variant="success"
                    size="sm"
                    className="me-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>

                  <Button variant="danger" size="sm" className="me-1 " onClick={handleReset}>
                    Reset
                  </Button>

                  <Button variant="secondary" size="sm" onClick={exportToPDF}>
                    PDF
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
      </Col>
      </Row>
      <Row className="mb-4">
        <Col xl={12} md={12} xs={12} className="mb-4">
            <Card className="mt-2">
                <Card.Body className="ps-1 pe-1">
                    {loading ? (
                        <div className="container vh-100">
                            <div className="d-flex align-items-center justify-content-center h-90">
                                <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                      <div ref={pdfRef} className="table-container">
                         <div className="table-responsive">
                        <DataTable
                          data={data}
                          columns={columns}
                          className="table bg-secondary-row2 white-row text-white"
                          options={{
                            paging: true,
                            searching: true,
                            ordering: false,
                            responsive: true,
                            autoWidth: false,
                            lengthChange: true, 
                            pageLength: 100,
                             ...options,
                            rowCallback: function (row, data) {
                                if (data.name.includes('(M)')) {
                                    $(row).addClass('master-sum-row');
                                } else if (data.name.includes('ZZZ-TOTAL')) {
                                    $(row).addClass('gray-row');
                                } 
                            }
                          }}
                        />
                        </div>
                        </div>
                    )}

                </Card.Body>
            </Card>
            </Col>
      </Row>
    </> 
    );
}

export default Summaryreport;
